var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgListCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 10,
  viewBox: "0 0 16 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H10.7112V1.61147H0V0ZM0 3.22295H10.7112V4.83442H0V3.22295ZM0 6.4459H7.41542V8.05737H0V6.4459ZM14.8366 3.6935L10.7103 7.72138L9.64581 6.68117L8.48077 7.82129L10.7103 10L16 4.83442L14.8366 3.6935Z",
  fill: "#636766"
})));
export { SvgListCheck as ReactComponent };
export default __webpack_public_path__ + "2e2bd4e0bb2dc50ea5ea88177db6db27.svg";